// extracted by mini-css-extract-plugin
export var container = "_1s-0";
export var disabled = "_1s-4";
export var fullWidth = "_1s-3";
export var lined = "_1s-1";
export var selected = "_1s-5";
export var tab = "_1s-2";